import Vue from 'vue'

if (document.getElementById('vue-header')) {
    new Vue({
        el: '#vue-header',
        data() {
            return {
                isMenuOpen: false,
                scrollPos: 0,
                ww: window.innerWidth
            }
        },
        mounted() {
            window.addEventListener('scroll', (e) => {
                this.scrollPos = window.scrollY;
            });
            window.addEventListener('resize', (e) => {
                this.ww = window.innerWidth;
            });
        },
        methods: {
            toggleMenu(isMenuItem) {

                if(isMenuItem) {
                    if(this.ww <= 1024) {
                        this.isMenuOpen = !this.isMenuOpen;
                    }
                }

                if (this.isMenuOpen) {
                    document.body.style.overflow = 'hidden'
                } else {
                    document.body.style.overflow = 'scroll'
                }
            }
        }
    })
      
}